module.exports = __webpack_public_path__ + "img/mars-rover.fc46c776.jpg";